import { ScreenDirection, PaintStyle } from "../../drawing";
import { IValueRange } from "../../system";
import { TypeKeys } from "./TypeKeys";
import { AbstractSourceEditableItem } from "./AbstractSourceEditableItem";
import { IPaintable } from "./IPaintable";

export class BarItem extends AbstractSourceEditableItem implements IPaintable {
  constructor() {
    super(TypeKeys.BarItem);
  }

  range: IValueRange;
  stepCount: number;
  direction: ScreenDirection;
  paintStyle: PaintStyle;
  paintStyleOnEditing: PaintStyle;
  shouldDrawNarrow: boolean;
  
  protected createCloneInstance(): BarItem {
    return new BarItem();
  }

  protected applyMembers(clone: BarItem): void {
    super.applyMembers(clone);
    clone.range = this.cloneValue(this.range);
    clone.stepCount = this.cloneValue(this.stepCount);
    clone.direction = this.cloneValue(this.direction);
    clone.paintStyle = this.cloneValue(this.paintStyle);
    clone.paintStyleOnEditing = this.cloneValue(this.paintStyleOnEditing);
    clone.shouldDrawNarrow = this.cloneValue(this.shouldDrawNarrow);
  }
}
